/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './two-factor-auth-recovery-modal.component.html';
import {deferSignalStateWrite} from '../../common/util/template-state';
import {TwoFactorAuthRecoveryApiService} from '../../common/controller/two-factor-auth-recovery-api.service';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-two-factor-auth-recovery-modal',
  template
})
export class TwoFactorAuthRecoveryModalComponent implements OnInit {
  userId: string;
  networkId: string;

  verifyUserId: string | null = null;
  private readonly usersLoadingState = signal(true);
  private readonly verifyingUsersLoadingState = signal(true);
  private readonly usersState = signal<any[]>([]);
  private readonly verifyingUsersState = signal<any[]>([]);
  private readonly errorMessageState = signal<string | null>(null);
  private readonly pendingState = signal(false);

  get usersLoading(): boolean { return this.usersLoadingState(); }
  set usersLoading(value: boolean) { this.usersLoadingState.set(value); }
  get verifyingUsersLoading(): boolean { return this.verifyingUsersLoadingState(); }
  set verifyingUsersLoading(value: boolean) { this.verifyingUsersLoadingState.set(value); }
  get users(): any[] { return this.usersState(); }
  set users(value: any[]) { this.usersState.set(value); }
  get verifyingUsers(): any[] { return this.verifyingUsersState(); }
  set verifyingUsers(value: any[]) { this.verifyingUsersState.set(value); }
  get errorMessage(): string | null { return this.errorMessageState(); }
  set errorMessage(value: string | null) { this.errorMessageState.set(value); }
  get pending(): boolean { return this.pendingState(); }
  set pending(value: boolean) { this.pendingState.set(value); }

  constructor(
    public bsModalRef: BsModalRef,
    private readonly twoFactorAuthRecoveryApi: TwoFactorAuthRecoveryApiService
  ) {
  }

  ngOnInit(): void {
    this.twoFactorAuthRecoveryApi.getRecoveryUsers(this.userId, this.networkId).subscribe((page: any) => {
      deferSignalStateWrite(() => {
        this.users = page !== null ? page.results : [];
        this.usersLoading = false;
      });
    });
    this.twoFactorAuthRecoveryApi.getVerifyingUsers(this.userId).subscribe((page: any) => {
      deferSignalStateWrite(() => {
        this.verifyingUsers = page !== null ? page.results : [];
        this.verifyingUsersLoading = false;
      });
    });
  }

  saveAndClose(): void {
    if (this.pending) {
      return;
    }

    this.pending = true;
    this.errorMessage = null;
    this.twoFactorAuthRecoveryApi.submitVerifyUser(this.userId, this.verifyUserId, this.networkId)
      .subscribe({
        next: (result: any) => {
        if (result === true) {
          this.bsModalRef.hide();
        } else {
          deferSignalStateWrite(() => {
            this.errorMessage = result.data.text;
            this.pending = false;
          });
        }
        },
        error: () => {
          deferSignalStateWrite(() => {
            this.pending = false;
          });
        }
      });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
